/**
 * Tooltip system for map hover interactions
 */

import type { Location } from '@/qud/types';

export interface HeatmapInfo {
  blueprintName: string;
  expectedSpawns: number;
}

export class Tooltip {
  private element: HTMLElement;
  private visible: boolean = false;

  constructor(containerId: string = 'tooltip') {
    const existing = document.getElementById(containerId);
    if (existing) {
      this.element = existing;
    } else {
      this.element = document.createElement('div');
      this.element.id = containerId;
      this.element.className = 'tooltip';
      document.body.appendChild(this.element);
    }
  }

  show(location: Location, x: number, y: number, heatmapInfo?: HeatmapInfo): void {
    let html = `
      <div class="tooltip-title">${this.escapeHtml(location.name)}</div>
      <div class="tooltip-description">${this.escapeHtml(location.description)}</div>
    `;

    if (heatmapInfo) {
      html += `
        <div class="tooltip-heatmap">
          <div class="tooltip-heatmap-label">${this.escapeHtml(heatmapInfo.blueprintName)}</div>
          <div class="tooltip-heatmap-value">${heatmapInfo.expectedSpawns.toFixed(6)} expected</div>
        </div>
      `;
    }

    this.element.innerHTML = html;

    // Position tooltip near cursor
    const rect = this.element.getBoundingClientRect();
    const offsetX = 15;
    const offsetY = 15;

    let left = x + offsetX;
    let top = y + offsetY;

    // Keep tooltip on screen
    if (left + rect.width > window.innerWidth) {
      left = x - rect.width - offsetX;
    }
    if (top + rect.height > window.innerHeight) {
      top = y - rect.height - offsetY;
    }

    this.element.style.left = `${left}px`;
    this.element.style.top = `${top}px`;
    this.element.style.display = 'block';
    this.visible = true;
  }

  hide(): void {
    this.element.style.display = 'none';
    this.visible = false;
  }

  isVisible(): boolean {
    return this.visible;
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
